/* eslint-disable @typescript-eslint/typedef */
import { createSelector } from '@reduxjs/toolkit';
import { storeSelector } from '../Global/StoreSelector';

const lastInput = createSelector(storeSelector, (state) => state.inputHistory.inputHistory.slice(-1)[0]);

export default {
  lastInput
};
